import { select, event, format, timeFormat } from "d3";
import { grayLightBackground } from "@/_core/_helpers/_parametric_tools";
import { hLineCreate, vLineCreate } from "@/_core/charts/D3ChartHoverHelpers";
import { createTooltips, mouseDate } from "@/_core/charts/TechnicalAnalysis";

export function DotPlotHover(_this, colorTheme) {
  const auxName = "dotPlot";
  let xTooltipWidth = 80;
  let yTooltip = createTooltips(
    _this.chartElements.svgNode,
    _this.currencyFormat,
    "",
    xTooltipWidth,
    _this.colorTheme,
    auxName
  );
  let xTooltip = yTooltip["xTooltip"];
  yTooltip = yTooltip["yTooltip"];
  hLineCreate(
    _this.chartElements.svgNode,
    auxName,
    grayLightBackground(colorTheme),
    1
  );
  vLineCreate(
    _this.chartElements.svgNode,
    auxName,
    grayLightBackground(colorTheme),
    1
  );

  function mouseover() {
    event.preventDefault();
    const xPixels = Math.max(
      Math.min(
        event.layerX - _this.chartElements.svgNode.margin.left,
        _this.chartElements.svgNode.width
      ),
      0
    );
    var xt = _this.chartElements.svgNode.x;
    let ytY = _this.chartElements.svgNode.y;
    let selData = mouseDate(
      xt.invert(xPixels),
      _this.allData.dotsProjections,
      "objective_date"
    );
    const yPixels = Math.max(
      Math.min(
        event.layerY - _this.chartElements.svgNode.margin.top,
        _this.chartElements.svgNode.height
      ),
      0
    );
    let yRate = ytY.invert(yPixels);
    yTooltip
      .style("opacity", 1)
      .style(
        "left",
        _this.chartElements.svgNode.width +
          _this.chartElements.svgNode.margin.left +
          1 +
          "px"
      )
      .style(
        "top",
        yPixels + _this.chartElements.svgNode.margin.top - 11 + "px"
      )
      .html(format(_this.formatVars.currencyFormat)(yRate));
    xTooltip
      .style("opacity", 1)
      .style(
        "left",
        xt(selData.objective_date) +
          _this.chartElements.svgNode.margin.left -
          xTooltipWidth / 2 +
          "px"
      )
      .style(
        "top",
        _this.chartElements.svgNode.height +
          _this.chartElements.svgNode.margin.top +
          2 +
          "px"
      )
      .html(timeFormat(_this.formatVars.dateFormat)(selData.objective_date));
    _this.dataHover = selData;

    select(".hHoverLinedotPlot")
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);

    let xPix = xt(selData.objective_date);

    select(".vHoverLinedotPlot")
      .style("opacity", 1)
      .attr("x1", xPix)
      .attr("x2", xPix);
  }
  function mouseout() {
    yTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");
    xTooltip
      .style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");
    select(".hHoverLinedotPlot").style("opacity", 0);
    select(".vHoverLinedotPlot").style("opacity", 0);
  }
  _this.chartElements.svgNode
    .append("defs")
    .append("clipPath")
    .attr("id", "clip" + auxName + auxName)
    .append("rect")
    .attr("width", _this.chartElements.svgNode.width)
    .attr("height", _this.chartElements.svgNode.height);

  var hoverGroup = _this.chartElements.svgNode
    .append("g")
    .attr("class", "hoverParent" + auxName + auxName)
    .attr("clip-path", `url(#clip${auxName + auxName})`);
  hoverGroup
    .append("rect")
    .attr("width", _this.chartElements.svgNode.width)
    .attr("height", _this.chartElements.svgNode.height)
    .style("fill", "rgba(0,0,0,0)")
    .on("mouseover", mouseover)
    .on("mousemove", mouseover)
    .on("mouseout", mouseout);
}
